module.exports = __webpack_public_path__ + "static/computer-work-408655925941861d265f09022858365f.png";